import ApiResourceManager from '../ApiResourceManager';

/**
 * The roots a partner's restaurants' shops are served under, as `{slug}.{root}`.
 *
 * The partner endpoints act on the signed-in partner admin's own provider and are gated
 * on the provider's `partner_custom_shop_domain` flag (403 outside the pilot). A root that
 * is not the partner's own — another partner's, a platform root — answers 404.
 * `getForProvider` is the read-only staff mirror support uses from the Partners page.
 * The reads are `get`, although they answer a list, to match the partner's other domain
 * screen (`PartnerDashboardDomainManager`).
 */
export default class PartnerShopDomainsManager extends ApiResourceManager {
  get = () =>
    this.request({
      method: 'GET',
      url: '/partner-settings/shop-domains',
    });

  connect = (host) =>
    this.request({
      method: 'POST',
      url: '/partner-settings/shop-domains',
      data: { host },
    });

  // Re-asserts the root on Vercel and re-checks its records. Throttled server-side.
  verify = (id) =>
    this.request({
      method: 'POST',
      url: `/partner-settings/shop-domains/${id}/verify`,
    });

  setPrimary = (id) =>
    this.request({
      method: 'PUT',
      url: `/partner-settings/shop-domains/${id}/primary`,
    });

  unlink = (id) =>
    this.request({
      method: 'DELETE',
      url: `/partner-settings/shop-domains/${id}`,
    });

  getForProvider = (serviceProviderId) =>
    this.request({
      method: 'GET',
      url: '/service-provider-shop-domains',
      headers: { 'x-on-behalf-of-service-provider': serviceProviderId },
    });
}
